import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from 'dg-org-search-lib/lib/models/dg-org-search.model';
import moment from 'moment';
import { NgxBarcodeModule } from 'ngx-barcode';

@Component({
  selector: 'app-correspondance-ack',
  templateUrl: './correspondance-ack.component.html',
  styleUrls: ['./correspondance-ack.component.scss'],
})
export class CorrespondanceAckComponent implements OnInit {
  width = 2;
  height = 50;
  lineColor = 'var(--dg-primary)';
  lNo: string = '4/CMO/2022';
  from: string = '';
  corrNo: string = '';
  corrDesc: string = '';
  rDate: any = '02/12/2021';
  lDate: any = '02/12/2021';
  value: any;
  deptName: any;
  orgConfig = {
    prntId: '54',
    fetchPrntOrgOnlyFlag: 'false',
    multiselect: true,
    header: 'Submit',
    minLengthForSearch: 3,
    minLengthMessage: 'Please enter 3 or more characters ',
  };

  profileAttachTitle = '';
  isProfileComponent = true; //flag to indetify profile Attachment Component
  profileAcceptedType = ['png', 'jpeg', 'jpg'];
  profileMaxSize = 5000000;
  profileUniqueAttachID = 'User Profile';
  isAllowFileToAttachProfile = false;
  profileAttachID = ''; //130573304
  empPhotoAttachId = null;
  isAllowDelete = false;
  resData: any;
  constructor(
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {}

  ngOnInit(): void {
    // this.date = moment(this.date)?.format('DD-MMM-YYYY'); //02-Dec-2021
    this.http
      .get('/correspondence-mgmnt/get-ack-receipt?corrId=' + this.data[0].docId)
      .subscribe((res: any) => {
        console.log('printing the resulted data', res);
        this.resData = res.data;
        this.empPhotoAttachId = '130014667';
        this.value = res.data.barCode;
        this.from = res.data.initiatorName;
        this.corrNo = res.data.corrNo;
        this.lNo = res.data.letterNumber;
        this.deptName = res.data.departmentName;
        this.corrDesc = res.data.corrDesc;
        this.rDate = moment(res.data.receivedDate)?.format('DD-MMM-YYYY');
        this.lDate = moment(res.data.letterDated)?.format('DD-MMM-YYYY');
      });
  }
  selectedOrgs = ['33'];
  getData3(res: any): void {
    console.log('reponse', res);
  }
}
